import React, { useContext, useEffect } from "react";
import DeleteButton from "../buttons/toolbar/DeleteButton";
import OnairToggleButton from "../buttons/toolbar/OnairToggleButton";
import PenButton from "../buttons/toolbar/PenButton";
import SettingScreenButton from "../buttons/toolbar/SettingScreenButton";
import ShareButton from "../buttons/toolbar/ShareButton";
import ScreenSettingModal from "../screen/ScreenSettingModal";
import HomeButton from "../buttons/toolbar/HomeButton";
import HomeMobileModal from "../navbars/HomeMobileModal";
import { IToolbarMobileSelectorParams } from "../../app/models/toolbar";
import { RootStoreContext } from "../../app/stores/rootStore";
import { observer } from "mobx-react-lite";
import ColorMobileModal from "../mobile/ColorMobileModal";
import NoteModalContainer from "../containers/NoteModalContainer";

const MobileToolbar: React.FC<IToolbarMobileSelectorParams> = ({
  languageSelectionConfig,
  contentConfig,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { loadToolbar, toolbar, currentBrowsePageContent } =
    rootStore.commonStore;
  const { isToShowScreensTab } = rootStore.screensStore;

  useEffect(() => {
    const contentId = contentConfig ? contentConfig.contentId : 0;
    loadToolbar(contentId).then().catch();
  }, [loadToolbar, contentConfig]);

  if (!toolbar) return <></>;
  const { tools } = toolbar;

  return (
    <>
      <div className="buttonContainerMobile">
        {(languageSelectionConfig &&
          currentBrowsePageContent &&
          currentBrowsePageContent.languages &&
          currentBrowsePageContent.languages.availabeLanguages.length > 1) ||
        (contentConfig && contentConfig.enableNotes) ? (
          <div className="divMobileButton">
            <HomeButton />
          </div>
        ) : null}
        {tools.pen && (
          <div className="divMobileButton">
            <PenButton />
          </div>
        )}
        {tools.delete && (
          <div className="divMobileButton">
            <DeleteButton />
          </div>
        )}
        {isToShowScreensTab && (
          <div className="divMobileButton">
            <SettingScreenButton />
          </div>
        )}
        {isToShowScreensTab && (
          <div className="divMobileButton">
            <OnairToggleButton />
          </div>
        )}
        {toolbar.canShare && (
          <div className="divMobileButton">
            <ShareButton />
          </div>
        )}
      </div>

      <HomeMobileModal
        languageSelectionConfig={languageSelectionConfig}
        contentConfig={contentConfig}
      />
      <ScreenSettingModal />
      <ColorMobileModal />
      <NoteModalContainer />

    </>
  );
};

export default observer(MobileToolbar);
